//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"CenterAxis",1,"Axis",0],[0,"CenterPlane",1,"Plane",0],[0,"Description",1,0],[0,"Diameter",1,0],[0,"FixtureType",1,0],[0,"JawWidth",1,0],[0,"MaxClampDiameter",1,0],[0,"MaxClampWidth",1,0],[0,"MaxJawHeight",1,0],[0,"MinClampDiameter",1,0],[0,"MinClampWidth",1,0],[0,"MinJawHeight",1,0],[0,"SaveFlag",1,0]],[[["index","frontFace","backface","bottomFace"],"SetMillStep",{},4,0],[["index","frontFace","backface","bottomFace"],"GetMillStep",{},1,0],[["index"],"DeleteMillStep",{},1,0],[["index","jawFaces","bottomFace"],"SetTurnStep",{},3,0],[["index","nJaws","jawFaces","bottomFace"],"GetTurnStep",{},1,0],[["index"],"DeleteTurnStep",{},1,0],[["libRef"],"ExportFixture",{},1,0]],[]];
SPLM.CAM.SetupFixture = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.SetupFixture";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.SetupFixture.Type = Object.freeze({
    "Mill" : "Mill", "Turn" : "Turn"});

SPLM.CAM.SetupFixture.SaveFlags = Object.freeze({
    "Replace" : "Replace", "CreateNew" : "CreateNew"});

export default SPLM;